/**
 * Socket event constants
 * Centralizes socket event names for consistency
 */

export const SOCKET_EVENTS = {
  // Connection events
  CONNECT: 'connect',
  DISCONNECT: 'disconnect',
  ERROR: 'error',

  // Auction events
  JOIN_AUCTION: 'joinAuction',
  LEAVE_AUCTION: 'leaveAuction',
  AUCTION_STATUS: 'auctionStatus',
  BID_PLACED: 'bidPlaced',
  PLAYER_SOLD: 'playerSold',
  PLAYER_UNSOLD: 'playerUnsold',
  PLACE_BID: 'placeBid',
  START_AUCTION: 'startAuction',
  APPROVE_SALE: 'approveSale',
  SKIP_PLAYER: 'skipPlayer',
  TEAM_OPTED_OUT: 'teamOptedOut',
  NEXT_PLAYER: 'nextPlayer',
  POOL_COMPLETED: 'poolCompleted',
  NO_PLAYERS_LEFT: 'noPlayersLeft',
} as const;

export type SocketEvent = (typeof SOCKET_EVENTS)[keyof typeof SOCKET_EVENTS];
